import {
    GET_CATEGORIES_SUCCESS,
    GET_CATEGORIES_FAIL,
    GET_CATEGORIES_LIST_SUCCESS,
    GET_CATEGORIES_LIST_FAIL,
    GET_CATEGORY_SUCCESS,
    GET_CATEGORY_FAIL,
    GET_MAIN_CATEGORIES_SUCCESS,
    GET_MAIN_CATEGORIES_FAIL
} from '../actions/types';

const initialState = {
    categories: null
};

const initialStateCategoriesFull = {
    mainCategories : null,
    categories: null,
    category: null,
    next : null,
    previous : null,
    count : null,
};
export default function Categories(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case GET_CATEGORIES_SUCCESS:
            return {
                ...state,
                categories: payload.categories
            }
        case GET_CATEGORIES_FAIL:
            return {
                ...state,
                categories: null
            }
        default:
            return state
    }
}

export function CategoriesFull(state = initialStateCategoriesFull, action) {
    const { type, payload } = action;

    switch(type) {
        case GET_MAIN_CATEGORIES_SUCCESS:
            return {
                ...state,
                mainCategories: payload.main_categories
            }
        case GET_MAIN_CATEGORIES_FAIL:
            return {
                ...state,
                mainCategories: null
            }
        case GET_CATEGORIES_LIST_SUCCESS:
            return {
                ...state,
                categories: payload.results,
                next: payload.next,
                previous: payload.previous,
                count: payload.count
            }
        case GET_CATEGORIES_LIST_FAIL:
            return {
                ...state,
                categories: null,
                next: null,
                previous: null,
                count: null
            }
        case GET_CATEGORY_SUCCESS:
            return {
                ...state,
                category: payload
            }
        case GET_CATEGORY_FAIL:
            return {
                ...state,
                category: null
            }
        default:
            return state
    }
}